export default __webpack_public_path__ + "static/media/house5.093cffcd.jpg";